import axios from 'axios'
import qs from 'qs'
import {
    Message
} from 'element-ui'
let DOMAIN = 'https://bshszh-api.baoshanhszh.cn/'
// DOMAIN = "http://192.168.1.238:9999/"

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'

axios.interceptors.request.use(function (config) {
    return config
}, function (error) {
    return Promise.reject(error)
});
// 响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                Message.error('错误请求')
                break
            case 401:
                Message.error('未授权，请重新登录')
                break
            case 403:
                Message.error('拒绝访问')
                break
            case 404:
                Message.error('请求错误,未找到该资源')
                break
            case 405:
                Message.error('请求方法未允许')
                break
            case 408:
                Message.error('请求超时')
                break
            case 500:
                Message.error('服务器端出错')
                break
            case 501:
                Message.error('网络未实现')
                break
            case 502:
                Message.error('网络错误')
                break
            case 503:
                Message.error('服务不可用')
                break
            case 504:
                Message.error('网络超时')
                break
            case 505:
                Message.error('http版本不支持该请求')
                break
            default:
                Message.error(`连接错误${err.response.status}`)
        }
    } else {
        Message.error('连接到服务器失败')
    }
    if (err.message == 'token failed') {
        Message.err("登录失效,请重新登录!")
    } else {
        Message.err(err.message)
    }
    return Promise.resolve(err.response)
})

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(DOMAIN + url, {
            params: params
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

export function post(url, params) {
    let obj = {
        ...params
    };
    // if (!JSON.parse(sessionStorage.getItem('token'))) {
    //     window.location.href = '/login'
    
    // }
    obj.token=sessionStorage.getItem("token")
    // axios.defaults.withCredentials = true;
    return new Promise((resolve, reject) => {
        axios.post(DOMAIN + url, qs.stringify(obj))
            .then(res => {
                if (res.data.status == 'ok') {
                    resolve(res.data)
                } else {
                    // 如果是token失效 跳转授权页面
                    if (res.data.error == "token failed") {
                        console.log("token 失效")
                        window.location.href = '/login'
                    }
                    Message.error(`${res.data.msg}`)
                }
            })
            .catch(err => {
                reject(err.data)
            })
    })
}

// 上传图片
export function upLoaderImg(event) { // file为 你读取成功的回调文件信息
    let file = event.target.files[0];
    let param = new FormData(); // 创建form对象
    param.append("file", file, file.name); // 通过append向form对象添加数据
    // param.append("type", "1"); // 添加form表单中其他数据
    // console.log(param.get('file')) // FormData私有类对象，访问不到，可以通过get判断值是否传进去
    let config = {
        headers: {
            "content-type": "application/x-www-from-urlencoded"
        }
    };
    return new Promise((resolve, reject) => {
        // 把 uploadUrl 换成自己的 上传路径
        axios.post(DOMAIN + "/settingInterfaces/v1.0/uploadImg", param, config).then(res => {
            if (res && res.data && res.data.status === 'ok') { // 如果为真 resolve出去
                resolve(res.data)
            } else {
                // 否则 Toast 提示
                this.$message({
                    message: res.data && (res.data.msg),
                    type: "error"
                })
                reject(res.data)
            }
        }).catch(err => {
            this.$message({
                message: "系统异常",
                type: "error"
            })
            reject(err)
        })
    })

}
export function upload(file) { //file为 你读取成功的回调文件信息
    //new 一个FormData格式的参数
    let params = new FormData()
    params.append('file', file)
    let config = {
        headers: { //添加请求头
            'Content-Type': 'multipart/form-data'
        }
    }
    return new Promise((resolve, reject) => {
        //把 uploadUrl 换成自己的 上传路径
        axios.post(DOMAIN + '/settingInterfaces/v1.0/uploadImg', params, config).then(res => {
            if (res.data.status == 'ok') { //如果为真 resolve出去
                resolve(res.data.data)
            } else {
                //否则 Toast 提示
                this.$message({
                    message: res.data && (res.data.msg),
                    type: "error"
                })
                reject(res.data)
            }
        }).catch(err => {
            this.$message("系统异常")
            reject(err)
        });
    })
}